/* eslint-disable ember/no-computed-properties-in-native-classes, warp-drive/no-legacy-request-patterns */
import Fragment from 'ember-data-model-fragments/fragment';
import { computed } from '@ember/object';
import { service } from '@ember/service';
import type { Type } from '@warp-drive/core/types/symbols';
import { attr } from '@warp-drive/legacy/model';
import type StoreService from '@linc-technologies/linced-common/services/store';

// Proto: events.CostMappingOption.
export default class CostMappingOption extends Fragment {
  declare [Type]: 'events/cost-mapping-option';

  // Services
  @service
  declare store: StoreService;

  @attr('number', { defaultValue: 0 })
  declare ledgerItemId: number;

  @computed('ledgerItemId')
  get ledgerItem() {
    if (this.ledgerItemId) {
      // Prefer peek to avoid triggering async fetches in a fragment computed
      return this.store.peekRecord('finance/ledger-item', this.ledgerItemId);
    }
  }

  @attr('string', { defaultValue: '' })
  declare value: string;

  @attr('string', { defaultValue: '' })
  declare description: string;

  @attr('number', { defaultValue: 0 })
  declare amount: number;

  @attr('string', { defaultValue: '' })
  declare note: string;
}
